import { Controller } from '@hotwired/stimulus'
// this is just an example. To see it live add the attribute data-controller="home" to an element
export default class extends Controller {
    connect() {
        console.log('Home 🏠', this.element)
    }
}
